<div class="dashletActivity">
  <img class="dashletActivity__icon" [src]="EIconPath.BASIC_FIELD_LOCATION" />
  <div class="dashletActivity__text">{{ 'changed_location' | ppTranslate }}.</div>
</div>
